/** Bump this when Terms or Privacy text changes. Officers must re-accept. */
export const LEGAL_POLICY_VERSION = '2026-08-24-dpdp';

export const LEGAL_EFFECTIVE_DATE = '24 August 2026';

export const LEGAL_COMPANY_NAME = 'Outris Imaging Pvt. Ltd.';
export const LEGAL_COPYRIGHT_YEAR = 2026;

export const LEGAL_CONTACT_EMAIL = 'support@outris.com';
export const LEGAL_DEMO_EMAIL = 'demo@outris.com';
export const LEGAL_PRIVACY_EMAIL = 'privacy@outris.com';
export const LEGAL_GRIEVANCE_NAME = 'Saurabh Sethi';
export const LEGAL_GRIEVANCE_EMAIL = 'saurabh@outris.com';
export const LEGAL_REGISTERED_OFFICE =
    '221, JMD Megapolis, Sector 48, Gurgaon, India — 122018';
